import React from 'react';
import { convertDate } from 'src/utils/common';
import { NoRecords } from 'src/reusable';

const TourAppliedList = props => {
  const { data, type, renderDataStatus } = props;
  let list = null;
  if (data?.length) {
    list = data.map((item, index) => {
      return (
        <tr key={index}>
          <th scope="row">{index + 1}</th>
          <td>{convertDate(item?.applied_from)}</td>
          <td>{convertDate(item?.applied_to)}</td>
          <td>{item.visiting_destination}</td>
          <td>{item?.reason || ''}</td>
          <td>{renderDataStatus(item, type)}</td>
          <td>{convertDate(item.created_at, 'YYYY-MM-DD')}</td>
        </tr>
      );
    });
  }
  return (
    <table className="table">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Date From</th>
          <th scope="col">Date To</th>
          <th scope="col">Tour To</th>
          <th scope="col">Reason</th>
          <th scope="col">Approval Status</th>
          <th scope="col">Created Date</th>
        </tr>
      </thead>
      <tbody>{list || <NoRecords tag="tr" colSpan={7} />}</tbody>
    </table>
  );
};

export default TourAppliedList;
